import { modalConstants } from '../../constants'

const initialState = {
  title: '',
  type: '',
  message: '',
  isShow: false,
  params: '',
  orgparams: ''
}

export default function modal(state = initialState, action) {
  switch (action.type) {
    case modalConstants.MODAL_BAGIC:
      return {
        ...state,
        type: "SUCCESS",
        isShow: true,
        params: action.params,
        orgparams: action.orgparams
      }
    case modalConstants.MODAL_CLEAR:
      return {
        ...state,
        type: "SUCCESS",
        isShow: false,
        params: action.params 
      }
    default:
      return state
  }
}
